/*!
 * OutIn Nano page — theme-editor safe interactions.
 * Only Nano-specific behaviour lives here:
 *   1. Opening-video accessible play/pause + reduced-motion handling
 *   2. Ground-coffee / capsule brewing tabs (ARIA tabs, one video at a time)
 *   3. Ajax add-to-cart bridge: the shared Fino product form submits through
 *      the shared Mino cart drawer (window.MinoCart) when it is on the page,
 *      falling back to the native form submit when it is not.
 * Everything else (reveals, gallery, variant switching, quantity, Buy Now,
 * sticky buy, UGC carousel, FAQ, metric roll) is the shared
 * assets/fino-product-page.js + assets/mino.js, unchanged.
 */
(function () {
  if (window.__nanoPageLoaded) return;
  window.__nanoPageLoaded = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- 1. Opening video: accessible pause/play ---------- */
  function initOpening(root) {
    $all("[data-nano-opening]", root).forEach(function (sec) {
      if (sec.__nanoBound) return;
      sec.__nanoBound = true;
      var video = sec.querySelector("video");
      var btn = sec.querySelector("[data-nano-video-toggle]");
      if (!video) return;
      video.muted = true;
      video.playsInline = true;

      function setState(playing) {
        if (!btn) return;
        btn.setAttribute("aria-pressed", playing ? "true" : "false");
        btn.setAttribute("aria-label", playing ? btn.getAttribute("data-label-pause") : btn.getAttribute("data-label-play"));
        var play = btn.querySelector("[data-nano-ic-play]");
        var pause = btn.querySelector("[data-nano-ic-pause]");
        if (play) play.style.display = playing ? "none" : "";
        if (pause) pause.style.display = playing ? "" : "none";
      }
      if (reduce) {
        // Reduced motion: stay on the poster frame until the visitor presses play
        try { video.autoplay = false; video.removeAttribute("autoplay"); video.pause(); } catch (e) {}
        setState(false);
      } else {
        var p = video.play();
        if (p && p.catch) p.catch(function () { setState(false); });
      }
      video.addEventListener("play", function () { setState(true); });
      video.addEventListener("pause", function () { setState(false); });
      setState(!video.paused);
      if (btn) btn.addEventListener("click", function () {
        if (video.paused) { var q = video.play(); if (q && q.catch) q.catch(function () {}); }
        else video.pause();
      });
    });
  }

  /* ---------- 2. Brewing-mode tabs ---------- */
  function pausePanelVideo(panel) {
    $all("video", panel).forEach(function (v) { try { v.pause(); } catch (e) {} });
  }
  function initBrewing(root) {
    $all("[data-nano-brewing]", root).forEach(function (sec) {
      if (sec.__nanoBound) return;
      sec.__nanoBound = true;
      var tabs = $all("[role=tab]", sec);
      var panels = $all("[role=tabpanel]", sec);
      if (!tabs.length || !panels.length) return;

      function activate(idx, focusTab) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.setAttribute("aria-selected", on ? "true" : "false");
          t.tabIndex = on ? 0 : -1;
          if (on && focusTab) t.focus();
        });
        panels.forEach(function (p, i) {
          var on = i === idx;
          if (on) p.removeAttribute("hidden"); else { p.setAttribute("hidden", ""); pausePanelVideo(p); }
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { activate(i, false); });
        t.addEventListener("keydown", function (e) {
          var dir = 0;
          if (e.key === "ArrowRight" || e.key === "ArrowDown") dir = 1;
          else if (e.key === "ArrowLeft" || e.key === "ArrowUp") dir = -1;
          else if (e.key === "Home") { e.preventDefault(); activate(0, true); return; }
          else if (e.key === "End") { e.preventDefault(); activate(tabs.length - 1, true); return; }
          if (dir) { e.preventDefault(); activate((i + dir + tabs.length) % tabs.length, true); }
        });
      });

      // Per-panel play/pause control; only one brewing video plays at a time
      panels.forEach(function (p) {
        var v = p.querySelector("video");
        var play = p.querySelector("[data-nano-mode-play]");
        if (!v) return;
        v.muted = true; v.playsInline = true;
        function mark(on) {
          if (!play) return;
          play.classList.toggle("is-playing", on);
          play.setAttribute("aria-label", on ? play.getAttribute("data-label-pause") : play.getAttribute("data-label-play"));
          var ic = play.querySelector("[data-nano-ic-play]");
          var ip = play.querySelector("[data-nano-ic-pause]");
          if (ic) ic.style.display = on ? "none" : "";
          if (ip) ip.style.display = on ? "" : "none";
        }
        function toggle() {
          panels.forEach(function (o) { if (o !== p) pausePanelVideo(o); });
          if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } else v.pause();
        }
        v.addEventListener("play", function () { mark(true); });
        v.addEventListener("pause", function () { mark(false); });
        v.addEventListener("click", toggle);
        if (play) play.addEventListener("click", toggle);
        mark(false);
      });

      activate(0, false);
    });
  }

  /* ---------- 3. Ajax add-to-cart via the shared Mino cart drawer ---------- */
  function initCartBridge() {
    if (document.__nanoCartBridge) return;
    document.__nanoCartBridge = true;
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.id !== "fino-product-form") return;
      if (!window.MinoCart || !document.querySelector("[data-mino-cart]")) return; // native fallback
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      var btn = form.querySelector("[data-fino-add]");
      if (!idEl || !idEl.value) return;
      if (btn) { btn.dataset.label = btn.getAttribute("data-label-available") || btn.textContent; }
      window.MinoCart.add(idEl.value, qtyEl ? qtyEl.value : 1, btn);
    }, true);
  }

  /* ---------- Boot + theme-editor lifecycle ---------- */
  function init(root) {
    root = root || document;
    initOpening(root);
    initBrewing(root);
    initCartBridge();
  }
  if (document.readyState !== "loading") init(document);
  else document.addEventListener("DOMContentLoaded", function () { init(document); });

  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    $all("[data-nano-opening], [data-nano-brewing]", e.target).forEach(function (n) {
      try { delete n.__nanoBound; } catch (err) {}
    });
    $all("video", e.target).forEach(function (v) { try { v.pause(); } catch (err) {} });
  });
  document.addEventListener("shopify:section:select", function (e) {
    // Pause ambient videos while the merchant edits the section
    $all("[data-nano-opening] video", e.target).forEach(function (v) { try { v.pause(); } catch (err) {} });
  });
  document.addEventListener("shopify:block:select", function (e) {
    // Selecting a brewing-mode block activates its tab
    var panel = e.target.closest ? e.target.closest("[role=tabpanel]") : null;
    var sec = e.target.closest ? e.target.closest("[data-nano-brewing]") : null;
    if (panel && sec) {
      var panels = $all("[role=tabpanel]", sec);
      var idx = panels.indexOf(panel);
      var tab = $all("[role=tab]", sec)[idx];
      if (tab) tab.click();
    }
    if (e.target.scrollIntoView) e.target.scrollIntoView({ block: "center", behavior: "smooth" });
  });
})();
